import React from 'react';
import Locale from '../../domain/Locale';
import NoCookiesContent from '../../components/content/NoCookies';
import Layout from '../../components/Layout';
import { props } from 'tcomb-react';

@props({
  locale: Locale
})
export default class NoCookies extends React.Component {

  render() {
    const locale = this.props.locale;
    return (
      <Layout locale={locale}>
        <NoCookiesContent locale={locale} />
      </Layout>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/NoCookies.js
 **/